export default __webpack_public_path__ + "static/media/img-0377-switzerland-full-face.47e69c92.png";